import {create} from "zustand";

type HotelFeatureStorage = {
    multiCurrency: boolean;
    ordersEnabled: boolean;
    currencies?: {
        calendarCurrency?: string;
        financePropertyCurrency?: string;
        financeServicesCurrency?: string;
        financeOtherCurrency?: string;
    };
    setMultiCurrency: (multiCurrency: boolean) => void;
    setOrdersEnabled: (ordersEnabled: boolean) => void;
    setCurrencies: (filter: Partial<HotelFeatureStorage['currencies']>) => void;
};

export const useMultiCurrencyStorage = create<HotelFeatureStorage>((set) => ({
    currencies: {},
    multiCurrency: false,
    ordersEnabled: true,
    setMultiCurrency: (newValue) => {
        set({ multiCurrency: newValue });
    },
    setOrdersEnabled: (newValue) => {
        set({ ordersEnabled: newValue });
    },
    setCurrencies: (newCurrencies) => {
        set((state) => ({
            currencies: {
                ...state.currencies,
                ...newCurrencies,
            },
        }));
    },
}));
